import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { OnNumericValueEditedSubject } from './numeric-input-editable.model';

@Component({
  selector: 'sha-numeric-input-editable',
  templateUrl: './numeric-input-editable.component.html',
  styleUrls: ['./numeric-input-editable.component.css']
})
export class NumericInputEditableComponent implements OnInit, OnChanges {

  @Input() value = 1;
  @Input() minValue = 0;
  @Input() maxValue = 100;
  @Input() size = 5;

  @Output() onValueEdited = new EventEmitter<OnNumericValueEditedSubject>();
  inputValue = 1;
  isDisabled = true;

  constructor() { }

  ngOnInit() {
    this.inputValue = this.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.inputValue = changes['value'].currentValue;
  }

  public keyPressed(event: any) {
    if (event.keyCode === 13) {
      // Enter
      this.saveEdition(event);
    } else if (event.keyCode === 27) {
      // ESC
      this.cancelEdition(event);
    }
  }

  public enableEdition(event: any) {
    this.isDisabled = false;
  }

  public cancelEdition(event: any) {
    this.isDisabled = true;
    this.inputValue = this.value;
  }

  public saveEdition(event: any) {
    this.isDisabled = true;
    const subject = <OnNumericValueEditedSubject>{ oldValue: this.value, newValue: this.inputValue };
    this.onValueEdited.emit(subject);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/numeric-input-editable/numeric-input-editable.component.ts